/* eslint-disable no-undef */
import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    packageVersion: process.env.PACKAGE_VERSION || "0",
    menuDepartamento: null,
  },

  mutations: {
    setDepartamento (state, data) {
        state.menuDepartamento = data
    }
  },

  getters: {
    appVersion: (state) => {
      return state.packageVersion;
    },

    getMenuDepartamento: (state) => {
      return state.menuDepartamento
    }
  },
});
